/*=========================================================================================
  File Name: modulePostGetters.js
  Description: Post Module Getters
==========================================================================================*/

export default {
	getParsedPosts: state =>
		state.posts.map(post => ({
			...post,
			can_edit: !!post.can_edit,
			can_delete: !!post.can_delete,
			attachments: post.files || null,
			dateInfo: post.created_at || null,
			authorName: post.author ? post.author.name : "",
			authorAvatar: post.author ? post.author.avatar : null,
			categoryName: post.category ? post.category.title : "",
			peopleTagged: post.people && post.people.length > 0 ? post.people.map(people => people.name) : []
		})),
	getParsedFeaturePosts: state =>
		state.featurePosts.map(post => ({
			...post,
			can_edit: !!post.can_edit,
			can_delete: !!post.can_delete,
			attachments: post.files || null,
			dateInfo: post.created_at || null,
			authorName: post.author ? post.author.name : "",
			authorAvatar: post.author ? post.author.avatar : null,
			categoryName: post.category ? post.category.title : "",
			peopleTagged: post.people && post.people.length > 0 ? post.people.map(people => people.name) : []
		}))
};
